import { FC } from 'react';
import { Link } from 'react-router-dom';
import './BreadcrumbPage.scss';
import { AgentsCategoryModel } from '../../models/Agents/AgentsCategory/AgentsCategoryModel';
import { SectionsModel } from '../../models/Articles/Sections/SectionsModel';
import { SubsectionModel } from '../../models/Articles/Subsections/SubsectionModel';

interface BreadcrumbPageProps {
  category?: AgentsCategoryModel;
  parentSection?: SectionsModel;
  section?: SectionsModel;
  subsection?: SubsectionModel;
}

const BreadcrumbPage: FC<BreadcrumbPageProps> = ({ category, parentSection, section, subsection }) => {
  return (
    <div className="BreadcrumbPage" data-testid="BreadcrumbPage">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb bg-transparent">
          <li className="breadcrumb-item text-sm">
            <Link className="text-secondary" to={'/'}>
              Home
            </Link>
          </li>

          {category && (
            <li className="breadcrumb-item text-sm">
              <Link className="text-secondary" to={`/articles/categories/view/${category?.id || category?.category_id}`}>
                {category?.name ?? category?.category_name}
              </Link>
            </li>
          )}

          {parentSection && (
            <li className="breadcrumb-item text-sm">
              <Link className="text-secondary" to={`/articles/sections/view/${parentSection?.id || parentSection?.section_id}`}>
                {parentSection?.name || parentSection?.section_name}
              </Link>
            </li>
          )}

          {section && (
            <li className="breadcrumb-item text-sm">
              <Link className="text-secondary" to={`/articles/sections/view/${section?.id || section?.section_id}`}>
                {parentSection
                  ? (section?.name || section?.section_name || '').replace(
                      `${parentSection?.name || parentSection?.section_name} - `,
                      '',
                    )
                  : section?.name || section?.section_name}
              </Link>
            </li>
          )}

          {subsection && (
            <li className="breadcrumb-item text-sm" aria-current="page">
              <Link className="text-secondary" to={`/articles/subsections/view/${subsection?.id || subsection?.subsection_id}`}>
                {subsection?.name || subsection?.subsection_name}
              </Link>
            </li>
          )}
        </ol>

        {/* <h6 className="font-weight-bolder mb-0 text-white">{currentPage}</h6> */}
      </nav>
    </div>
  );
}

export default BreadcrumbPage;
